<template>


    <div class="main">
        <OfferBanner />
        <div class="mt-4"></div>
        <div class="mt-4"></div>
        <OfferDashboard />
    </div>


</template>


<script>


import OfferBanner from '../components/Offer/Offer-Banner.vue';
import OfferDashboard from '../components/Offer/Offer-Dashboard.vue';

export default {
  name: "OfferComponent",
    components: {
        OfferBanner,
        OfferDashboard,   
    }
};
</script>